<template>
  <header
    class="fixed top-0 left-0 flex items-center justify-between flex-shrink-0 w-full py-4 bg-white border-b navigation z-header viewport-gutter color-white border-au_gray-150"
  >
    <div class="container flex items-center justify-between w-full">
      <nav>
        <a v-if="href" :href="href" class="block logo" aria-label="Discover Airlines" />
        <router-link
          v-else
          :to="$i18nTo({ name: 'voucherSaleLanding' })"
          class="block logo"
          aria-label="Discover Airlines Logo"
        />
      </nav>
      <nav class="flex">
        <router-link
          class="lang-link text-4y-nightsky-blue mr-1"
          aria-label="Deutsche Sprache"
          :class="currentLocale === 'de' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: 'de'}}"
        >
          DE
        </router-link>

        <router-link
          class="lang-link text-4y-nightsky-blue"
          aria-label="English language"
          :class="currentLocale === 'en' && 'font-bold'"
          :to="{ ... $route, params: { ...$route.params, locale: undefined}}"
        >
          EN
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import Header from '~brand-components/base/shared/header'

export default Header.extend()
</script>

<style lang="scss" scoped>
.navigation {
  height: 60px;
}

.pdf-include {
  background: url("../../../images/lufthansa/hero/white_pixel.jpg");
}

.logo {
  width: 112px;
  height: 39px;
  background-size: 112px auto;
  background: url("../../../images/discover/logos/logo.svg") no-repeat left center;

  &:focus {
    outline: 1px solid #1E73AF;
    outline-offset: 4px;
  }
}

@media screen and (min-width: 768px) {
  .navigation {
    height: 88px;
  }
}

.lang-link {
  &:focus {
    outline: 1px solid #1E73AF;
  }
}
</style>
